module.exports = __webpack_public_path__ + "static/img/samajuri (41).4d815e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (41).jpg
// module id = dr33
// module chunks = 0